import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { Store } from "@mui/icons-material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import AnimatedSection from "../AnimatedSection";
import { gradients } from "../../../utils/theme";

/**
 * CTASection Component
 *
 * Final call-to-action section encouraging users to explore malls or get started.
 */
const CTASection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      id="contact"
      sx={{
        py: { xs: 4, sm: 5, md: 6, lg: 8 },
        background: gradients.navyLux,
        color: "white",
        textAlign: "center",
      }}
    >
      <Container maxWidth="md">
        <AnimatedSection>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem" },
              fontWeight: 700,
              mb: 2,
            }}
          >
            Transform Your Mall Experience
          </Typography>
          <Typography
            variant="h6"
            sx={{ mb: 4, opacity: 0.95, fontWeight: 400 }}
          >
            Skip queues. Find stores instantly. Never miss offers & events.
            Premium mall experience on WhatsApp.
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: 3,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Button
                variant="contained"
                size="large"
                startIcon={<Store />}
                onClick={() => navigate("/explore")}
                sx={{
                  background: gradients.gold,
                  color: "#1a237e",
                  px: 5,
                  py: 2,
                  fontSize: "1.125rem",
                  fontWeight: 700,
                  textTransform: "none",
                  boxShadow: "0 8px 24px rgba(255,215,0,0.3)",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #FFE066 0%, #FFD700 100%)",
                    boxShadow: "0 12px 32px rgba(255,215,0,0.4)",
                  },
                }}
              >
                Explore Malls
              </Button>
            </motion.div>
          </Box>
        </AnimatedSection>
      </Container>
    </Box>
  );
};

export default CTASection;
